import { USER_STORE_ID } from '@/constants/storeIds';
import { ref } from '@vue/composition-api';
import { defineStore } from 'pinia';

export const useUserStore = defineStore(USER_STORE_ID, () => {
    const isNewUserModalActive = ref(false);
    /**
     * @param {boolean} isModalActive 
     */
    const setNewUserModalActive = (isModalActive) => {
        isNewUserModalActive.value = isModalActive;
    };

    return {
        isNewUserModalActive,
        setNewUserModalActive
    };
});
